import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikField } from "@air/formik-field";
import { Eye, EyeClosed } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Input } from "@air/primitive-input";
import { useToggle } from "__barrel_optimize__?names=useToggle!=!react-use";
const PasswordInput = (param)=>{
    let { className, testId, label, name, disabled, size, description } = param;
    const fieldID = "Password";
    const [isValueVisible, togglePasswordVisibility] = useToggle(false);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ _jsx(FormikField, {
                id: name || "password",
                className: className,
                label: label || "Password *",
                description: description,
                component: /*#__PURE__*/ _jsx(Input, {
                    className: "w-full pr-9",
                    size: size,
                    disabled: disabled,
                    "data-testid": testId,
                    autoComplete: "new-password",
                    type: isValueVisible ? "text" : "password"
                }),
                name: name || "password"
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                size: "medium",
                className: "absolute right-1.5 top-1/2 mt-[11px] -translate-y-1/2",
                label: isValueVisible ? "Hide password" : "Show password",
                icon: isValueVisible ? Eye : EyeClosed,
                onClick: togglePasswordVisibility,
                "aria-controls": fieldID,
                "aria-expanded": isValueVisible
            })
        ]
    });
};
export default PasswordInput;
